import axios from "axios";
// import api from "./BaseServices";

// Define the shape of the user data
interface User {
  id: number;
  email: string;
  username: string;
  profile_picture_url?: string;
  banner_image_url?: string;
  description: string;
  role: string;
}

const BASE_URL = `${process.env.REACT_APP_API_URL}/auth`;

// Function to verify the token
export const verifyToken = async (): Promise<User | null> => {
  console.log(BASE_URL);
  try {
    const response = await axios.get(`${BASE_URL}/verifyToken`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Function to login
export const login = async (
  email: string,
  password: string
): Promise<User | null> => {
  try {
    const response = await axios.post(
      `${BASE_URL}/login`,
      {
        email,
        password,
      },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
};

// Function to login with Google
export const googleLogin = async (code: string): Promise<User | null> => {
  try {
    const response = await axios.post(
      `${BASE_URL}/googleLogin`,
      { code },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
};

// Function to logout
export const logout = async (): Promise<void> => {
  try {
    await axios.post(`${BASE_URL}/logout`, {}, { withCredentials: true });
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
};

type RegisterResult =
  | { status: "success"; user: User }
  | { status: "user_exists" }
  | { status: "error"; message: string };

export const register = async (
  email: string,
  password: string
): Promise<RegisterResult> => {
  try {
    const response = await axios.post(
      `${BASE_URL}/register`,
      { email, password },
      { withCredentials: true }
    );

    return { status: "success", user: response.data };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 409) {
        return { status: "user_exists" };
      }

      return {
        status: "error",
        message: error.response?.data?.message || "Registration failed",
      };
    }

    return { status: "error", message: "Unexpected error" };
  }
};

export const forgotPassword = async (email: string) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/forgot`,
      {
        email,
      },
      {
        withCredentials: true,
      }
    );

    if (response.status === 200) {
      return true;
    }
    return false;
  } catch (error) {
    console.error("forgotPassword failed", error);
    throw error;
  }
};

export const resetPassword = async (token: string, password: string) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/reset`,
      {
        token,
        password,
      },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("resetPassword failed", error);
    throw error;
  }
};
